import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {
  releaseCalendarFormFields
} from "../../../configs/release-calendar-config";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {CommonModule} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {
  ReleaseCalendarQueryParams,
  ReleaseCalendarData,
  ReleaseCalendarFormField,
  ReleaseCalendarResult, DialogData
} from "../../../types/release-calendar-types";
import {
  ReleaseCalendarService
} from "../../../services/release-calendar.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {LoaderComponent} from "../../../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-release-calendar-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatFormField,
    MatOption,
    MatSelect,
    CommonModule,
    MatButton,
    ReactiveFormsModule,
    MatLabel,
    LoaderComponent
  ],
  templateUrl: './release-calendar-modal.component.html',
  styleUrls: [
    './release-calendar-modal.component.scss',
    '../../../../../../core/components/modals/base-modal/base-modal.component.scss'
  ]
})
export class ReleaseCalendarModalComponent extends BaseModalComponent {
  private releaseCalendarService: ReleaseCalendarService = inject(ReleaseCalendarService);

  protected readonly releaseCalendarFormFields = releaseCalendarFormFields;
  public formGroup: FormGroup = new FormGroup({});
  public dialogData = inject<DialogData>(MAT_DIALOG_DATA);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.initForm();
    this.setFormFields();
  }

  public async handelFetchReleaseCalendarData() {
    const monthName = this.getMonthName(this.formGroup.value.month);
    const queryParams: ReleaseCalendarQueryParams = {
      month: this.formGroup.value.month,
      year: this.formGroup.value.year,
      showAllTeams: true
    };

    this.loadingService.setIsLoadingState(true);
    await this.fetchReleaseCalendarData(queryParams, monthName);
  }

  private initForm(): void {
    const group: { [key: string]: FormControl } = {};

    releaseCalendarFormFields.forEach((field: ReleaseCalendarFormField) => {
      group[field.fieldName] = new FormControl('', []);
    });

    this.formGroup = new FormGroup(group);
  }

  private setFormFields(): void {
    this.formGroup.patchValue({
      year: this.dialogData.data?.year,
      month: this.dialogData.data?.month
    });
  }

  private async fetchReleaseCalendarData(queryParams: ReleaseCalendarQueryParams, monthName: string): Promise<void> {
    this.releaseCalendarService.getReleaseCalendarData(queryParams)
      .then((data) => {
        const result: ReleaseCalendarResult = {
          data: data,
          releaseCalendarSelectedOptions: {
            ...this.formGroup.value,
            monthName: monthName
          }
        };

        this.dialogRef.close(result);
      })
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private getMonthName(month: number): string {
    const formatter = new Intl.DateTimeFormat('ru-RU', { month: 'long' });
    const date = new Date(2000, month - 1);
    return formatter.format(date);
  }
}
